import { ResourceLanguage } from 'i18next';
import { TranslationExtensionInterface } from '../../../../extension/interface/translation.extension.interface';

/**
 * Copy shared only between LUNCH and AT_LUNCH (meal-receipt flows) - doesn't apply to the other
 * 3 benefits, so it's split out from ReceiptTranslationExtension rather than added to it.
 * Resolved via lunchReceiptBenefitKeys in ../receiptTranslation.ts, moduleName `lunchReceipt`.
 */
export class LunchReceiptTranslationExtension extends TranslationExtensionInterface {
  moduleName = 'lunchReceipt';

  get translations(): ResourceLanguage {
    return {
      infoPage: {
        title: 'Infos zum Essenszuschuss',
      },
      field: {
        total: 'Betrag der Mahlzeit',
        receiptType: 'Belegart',
      },
      lineItems: {
        toManualEntry: 'Manuelle Eingabe',
        skipAnalysis: 'Analyse überspringen',
        selectedSum: 'Summe:',
        pfandWarning: 'Pfand, Trinkgeld und Lieferkosten wurden automatisch entfernt',
      },
      receiptLineItemsChecklist:
        '<0>Wähle alle Posten, die Teil Deiner Mahlzeit waren</0><0>Pfand, Nonfood Artikel oder Alkoholika dürfen nicht im Betrag enthalten sein</0><0>EC Belege, sowie nur Getränke sind nicht gestattet</0>',
      receiptStep1Checklist:
        'Erfasse den Betrag wie am Beleg abgebildet:<0>Nutze den integrierten Taschenrechner, um die Posten Deiner Mahlzeit zu addieren</0><0>Wenn alle Posten des Belegs zu Deiner Mahlzeit gehören, gib den Gesamtbetrag ein</0><0>Pfand, Nonfood Artikel oder Alkoholika dürfen nicht im Betrag enthalten sein</0><0>EC Belege, sowie nur Getränke sind nicht gestattet</0>',
      receiptStep2Checklist:
        'Wähle das auf dem Beleg abgebildete Datum:<0>Es zählt das Ausstellungsdatum des Belegs</0><0>Pro Tag kann nur eine Mahlzeit eingereicht werden</0><0>Wenn Du mehrere Belege für einen Tag einreichen möchtest, fotografiere sie gemeinsam</0>',
      addReceiptFlow: {
        hintTotal: 'Gib den Betrag Deiner Mahlzeit ein',
        submitReceipt: 'Beleg einreichen',
      },
      dateHint: 'Gib das Datum Deiner Rechnung ein',
      placeholder: {
        comment: 'Gib hier an, welche Einzelposten Teil des obigen Betrags sind',
      },
    };
  }
}
